import React from 'react'
import i18next from 'i18next'
import hash from 'object-hash'
import { Trans } from 'react-i18next'
import { connect } from 'react-redux'
import { format, startOfToday, parseISO, addMinutes, addDays, subDays } from 'date-fns'
import { Card, Modal, Button } from 'react-bootstrap'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import { getConstants } from 'src/lib/constants'
import moment from 'moment'
import 'moment/locale/it'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './calendar_view.css'
import { getAppointments, resetAppointments } from 'src/store/calendar'
import { getAllBrands } from 'src/store/brand'
import { getAllUsers } from 'src/store/users'
import { getAllCategories } from 'src/store/appointments'
import AppointmentForm from 'src/components/appointments/appointment_form'
import FilterGroup from 'src/components/system_wide/filter_group'
import CheckboxFilter from 'src/components/system_wide/checkbox_filter'
import SelectAgentsModal from 'src/components/system_wide/select_agents_modal'

moment.locale('it')
const localizer = momentLocalizer(moment)

const { t } = i18next

const mstp = state => {
  let { appointments, show_form, pending, current_appointment } = state.calendar
  let { id, business_role_priority } = state.userInfo
  let { all_brands: brands } = state.brands
  let { all_users: users } = state.users
  let { categories } = state.appointments

  return {
    user_id: id,
    pending,
    show_form,
    appointments,
    current_appointment,
    business_role_priority,
    brands,
    users,
    categories,
  }
}

const messages = {
  today: 'Oggi',
  previous: 'Precedente',
  next: 'Successivo',
  month: 'Mese',
  week: 'Settimana',
  day: 'Giorno',
  agenda: 'Agenda',
  date: 'Data',
  time: 'Ora',
  event: 'Evento',
  allDay: 'Tutto il giorno',
  noEventsInRange: 'Nessun evento in questo intervallo',
}

const formats = {
  timeGutterFormat: 'HH:mm',
  eventTimeRangeFormat: ({ start, end }) => `${moment(start).format('HH:mm')} - ${moment(end).format('HH:mm')}`,
  dayFormat: 'D',
  weekdayFormat: 'ddd',
  monthHeaderFormat: 'MMMM YYYY',
  dayRangeHeaderFormat: ({ start, end }) => `${moment(start).format('MMMM D')} - ${moment(end).format('MMMM D')}`,
}

const EventPreview = ({ events, onEventClick }) => (
  <div className="d-flex flex-column gap-2">
    {events.map(event => {
      let visitClass = 'visit'

      switch (event.type) {
        case 'engagement':
          visitClass += ' type-engagement'
          break
        case 'training_with_placement':
          visitClass += ' type-training-place'
          break
        case 'training_without_placement':
          visitClass += ' type-training-no'
          break
        case 'push_activity':
          visitClass += ' type-push'
          break
        default:
          break
      }
      return (
        <div
          className="d-flex align-items-center"
          key={event.id}
          style={{ cursor: 'pointer' }}
          onClick={() => onEventClick(event)}>
          <div>
            <span
              className={`me-1 ${visitClass}`}
              style={{
                width: '8px',
                height: '8px',

                borderRadius: '50%',
                display: 'inline-block',
              }}
            />
            {event.dealer_brand.dealer.business_name}
          </div>
        </div>
      )
    })}
  </div>
)

class CalendarView extends React.Component {
  state = {
    selected_date: startOfToday(),
    isMobile: window.innerWidth <= 768,
    show: false,
    current_appointment: null,
    view: 'month',
    views: ['month', 'week', 'day', 'agenda'],
    filtered_appointment_types: [],
    filtered_brands: [],
    filtered_users: [],
    filtered_statuses: [],
    ready: false,

    filters_hash: '',
  }

  initialFiltersHash = ''
  selectAgentsModalRef = null
  views = []
  filter_statuses = []
  appointmentTypes = getConstants().appointment_types
  appointmentTypesColors = getConstants().appointment_types_colors

  constructor(props) {
    super(props)
    this.selectAgentsModalRef = React.createRef()
    this.filter_statuses = getConstants().appointment_statuses
    this.filter_statuses = Object.keys(this.filter_statuses).map(k => ({ id: k, name: this.filter_statuses[k] }))
    this.state.filtered_statuses = this.filter_statuses.map(s => s.id)
    this.filter_appointment_types = Object.keys(this.appointmentTypes).map(k => ({
      id: k,
      name: this.appointmentTypes[k],
      color: this.appointmentTypesColors[k],
    }))
    this.state.filtered_appointment_types = this.filter_appointment_types.map(s => s.id)
  }

  async componentDidMount() {
    let views = this.getAvailableViews()
    await this.props.dispatch(getAllCategories())
    await this.props.dispatch(getAllBrands())
    await this.props.dispatch(getAllUsers({ filtered_roles_priority: [4] }))
    this.setState(
      {
        views,
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_users: this.props.users.map(u => u.id),
        filtered_appointment_types: this.filter_appointment_types.map(t => t.id),
        ready: true,
      },
      () => {
        let { filtered_brands, filtered_users, filtered_statuses, filtered_appointment_types } = this.state
        filtered_brands.sort()
        filtered_users.sort()
        filtered_statuses.sort()
        filtered_appointment_types.sort()
        this.initialFiltersHash = hash({
          filtered_brands: filtered_brands,
          filtered_users: filtered_users,
          filtered_statuses: filtered_statuses,
          filtered_appointment_types: filtered_appointment_types,
        })
        this.updateFiltersHash()
        this.calculateRangeDates(this.state.selected_date)
      }
    )
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    this.props.dispatch(resetAppointments())
  }

  updateFiltersHash = () => {
    let { filtered_brands, filtered_users, filtered_statuses, filtered_appointment_types } = this.state
    filtered_brands.sort()
    filtered_users.sort()
    filtered_statuses.sort()
    filtered_appointment_types.sort()

    this.setState({
      filters_hash: hash({ filtered_brands, filtered_users, filtered_statuses, filtered_appointment_types }),
    })
  }

  handleResize = () => {
    this.setState({ view: this.getAvailableViews() })
  }

  onChangeFilter = name => values => {
    if (name === 'filtered_users') {
      values = values.map(user => user.id)
    }
    this.setState({ [name]: values }, () => {
      this.updateFiltersHash()
      this.calculateRangeDates(this.state.selected_date)
    })
  }

  getAvailableViews = () => {
    const { business_role_priority } = this.props
    const isMobile = window.innerWidth <= 768

    if (business_role_priority === 4) {
      return isMobile ? ['agenda', 'day'] : ['month', 'week', 'agenda', 'day']
    } else if ([1, 2, 3].includes(business_role_priority)) {
      return isMobile ? ['agenda'] : ['month', 'agenda']
    }

    return ['agenda'] // Default fallback
  }

  calculateRangeDates = date => {
    const start_date = subDays(date, 40)
    const end_date = addDays(date, 40)

    this.props.dispatch(
      getAppointments({
        start_date: format(start_date, 'yyyy-MM-dd'),
        end_date: format(end_date, 'yyyy-MM-dd'),
        filtered_brands: this.state.filtered_brands,
        filtered_statuses: this.state.filtered_statuses,
        filtered_users: this.state.filtered_users,
        filtered_appointment_types: this.state.filtered_appointment_types,
      })
    )
    this.setState({ selected_date: date })
  }

  handleDateChange = (date, view) => {
    this.calculateRangeDates(date)
  }

  handleViewChange = view => {
    this.setState({ view })
    this.calculateRangeDates(this.state.selected_date)
  }

  handleEventClick = event => {
    const appointment_created_by = event.created_by
    const dealer = event.dealer_brand.dealer
    const brand = event.dealer_brand.brand
    const {
      id,
      dealer_brand_id,
      code,
      type,
      date,
      note,
      photos,
      contract,
      status,
      rejected_note,
      rejected_at,
      success_at,
    } = event

    const appointment = {
      id,
      dealer_brand_id,
      code,
      type,
      created_by: appointment_created_by.id,
      created_by_name: appointment_created_by.first_name + ' ' + appointment_created_by.last_name,
      dealer_id: dealer.id,
      piva: dealer.piva,
      business_name: dealer.business_name,
      date,
      note,
      photos,
      contract,
      brand_id: brand.id,
      brand_name: brand.name,
      place_id: dealer.place_id,
      address: dealer.address,
      merchandise_category_id: dealer.merchandise_category_id,
      contacts: dealer.contacts,
      status,
      rejected_note,
      rejected_at,
      success_at,
    }
    this.setState({ show: true, current_appointment: appointment })
  }
  closeAppointment = () => {
    this.setState({ show: false, current_appointment: null })
  }

  onResetFilters = () => {
    this.setState(
      {
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_statuses: this.filter_statuses.map(s => s.id),
        filtered_users: this.props.users.map(u => u.id),
        filtered_appointment_types: this.filter_appointment_types.map(t => t.id),
      },
      () => {
        this.updateFiltersHash()
        this.calculateRangeDates(this.state.selected_date)
      }
    )
  }

  render() {
    if (this.state.ready === false) return
    const { appointments, business_role_priority, brands, users, user_id } = this.props
    const {
      isMobile,
      current_appointment,
      filtered_brands,
      filtered_statuses,
      filtered_users,
      filtered_appointment_types,
      filters_hash,
    } = this.state
    let defaultView = isMobile ? 'agenda' : 'month'
    if (!this.state.views.includes(defaultView)) {
      defaultView = this.state.views[0]
    }

    let title_appointment_form = `${t('components.appointments.view_appointment', 'Visualizza visita')}: ${
      this.appointmentTypes[current_appointment?.type]
    }`

    return (
      <div className="card card-body container-fluid flex-fill d-flex flex-column px-0 pb-0 pt-2 mb-0">
        <div className="d-flex flex-column flex-fill">
          <div className="toolbar px-2 flex-wrap">
            <FilterGroup
              className="toolbar-item"
              showResetFilters={this.initialFiltersHash !== filters_hash}
              onResetFilters={this.onResetFilters}>
              <CheckboxFilter
                label={t('filter_appointment_types', 'Tipologia')}
                items={this.filter_appointment_types}
                filteredItems={filtered_appointment_types}
                onChangeFilter={this.onChangeFilter('filtered_appointment_types')}
                showSearch={true}
              />
              <CheckboxFilter
                label={t('filter_brands', 'Brand')}
                items={brands}
                filteredItems={filtered_brands}
                onChangeFilter={this.onChangeFilter('filtered_brands')}
                showSearch={true}
              />
              <CheckboxFilter
                label={t('filter_status', 'Stato')}
                items={this.filter_statuses}
                filteredItems={filtered_statuses}
                onChangeFilter={this.onChangeFilter('filtered_statuses')}
                showSearch={true}
              />
              {users.length > 0 && users[0].id !== user_id && (
                <Button
                  className="dropdown-toggle btn btn-primary"
                  onClick={() => this.selectAgentsModalRef.current.show({ selected_users: filtered_users })}>
                  <Trans i18nKey="filter_agents">Funzionari</Trans>
                </Button>
              )}
            </FilterGroup>
          </div>

          <Card className="shadow-lg border-0 rounded-3 card-calendar">
            <Card.Body className="d-flex flex-column p-0">
              <Calendar
                culture={'it'}
                key={this.state.views.length}
                localizer={localizer}
                events={appointments.map((event, index) => ({
                  id: `${event.id}_${index}`,
                  title: `Visita: ${event?.business_name ?? ''}`,
                  start: parseISO(event.date),
                  end: addMinutes(parseISO(event.date), 30),
                  events: [event],
                }))}
                onNavigate={(date, view) => this.handleDateChange(date, view)}
                onView={this.handleViewChange}
                views={this.state.views}
                defaultView={defaultView}
                step={60}
                timeslots={1}
                formats={formats}
                messages={messages}
                components={{
                  event: ({ event }) => {
                    return <EventPreview key={event.id} events={event.events} onEventClick={this.handleEventClick} />
                  },
                }}
                popup={true}
              />
            </Card.Body>
          </Card>
        </div>
        <Modal backdrop="static" centered show={this.state.show} onHide={this.closeAppointment} size="xl">
          <Modal.Header>
            <Modal.Title>{title_appointment_form}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column">
            <AppointmentForm
              appointmentFromProps={current_appointment}
              business_role_priority={business_role_priority}
              categories={current_appointment?.merchandise_category ? [current_appointment.merchandise_category] : []}
              readonly={true}
              closeForm={this.closeAppointment}
            />
          </Modal.Body>
        </Modal>
        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={users}
          brands={brands}
          selected_user={filtered_users}
          onChange={this.onChangeFilter('filtered_users')}
          multiSelection={true}
        />
      </div>
    )
  }
}

export default connect(mstp)(CalendarView)
